//
//
//
//
//
//

import VALIDATION_STATUS from '@/constants/assigment-validation-status'

export default {
  props: {
    type: {
      type: String,
      default: 'pending',
    },
  },
  computed: {
    icon() {
      return this.type === VALIDATION_STATUS.FINISHED ? 'check' : 'account'
    },
  },
}
